import React from "react";
import { ALL_OPTION } from "utility/constants";

export const ALLOCATION_STATUS = {
  APPROVED: "Approved",
  PENDING: "Pending",
  REQUESTED: "Requested",
  PROCESSED: "Processed",
  DOWNLOADED: "Downloaded",
  DISAPPROVED: "Disapproved",
  INPROGRESS: "In-Progress",
  RESUBMISSION: "For Resubmission",
  NOTELIGIBLE: "Not Eligible",
};

export const APPROVED_STATUS_LABEL = "Endorsed";

export const DISAPPROVED_STATUS_LABEL = "Pls See Comment";

export const ALLOWED_STATUS_TO_BUMP_ALLOCATION = [
  ALLOCATION_STATUS.APPROVED,
  ALLOCATION_STATUS.PENDING,
  ALLOCATION_STATUS.REQUESTED,
];

export const ALLOCATION_STATUS_FILTER = [
  { value: ALLOCATION_STATUS.REQUESTED, label: ALLOCATION_STATUS.REQUESTED },
  { value: ALLOCATION_STATUS.PENDING, label: ALLOCATION_STATUS.PENDING },
  { value: ALLOCATION_STATUS.APPROVED, label: APPROVED_STATUS_LABEL },
  { value: ALLOCATION_STATUS.PROCESSED, label: ALLOCATION_STATUS.PROCESSED },
  { value: ALLOCATION_STATUS.DOWNLOADED, label: ALLOCATION_STATUS.DOWNLOADED },
  { value: ALLOCATION_STATUS.DISAPPROVED, label: DISAPPROVED_STATUS_LABEL },
];

export const ALL_ALLOCATION_STATUS_OPTIONS = [
  {
    id: 7,
    label: "All",
    value: ALL_OPTION,
  },
  {
    id: 1,
    label: ALLOCATION_STATUS.PENDING,
    value: ALLOCATION_STATUS.PENDING,
  },
  {
    id: 2,
    label: ALLOCATION_STATUS.PROCESSED,
    value: ALLOCATION_STATUS.PROCESSED,
  },
  {
    id: 3,
    label: ALLOCATION_STATUS.INPROGRESS,
    value: ALLOCATION_STATUS.INPROGRESS,
  },
  {
    id: 4,
    label: APPROVED_STATUS_LABEL,
    value: ALLOCATION_STATUS.APPROVED,
  },
  {
    id: 5,
    label: DISAPPROVED_STATUS_LABEL,
    value: ALLOCATION_STATUS.DISAPPROVED,
  },
  {
    id: 6,
    label: ALLOCATION_STATUS.DOWNLOADED,
    value: ALLOCATION_STATUS.DOWNLOADED,
  },
  {
    id: 8,
    label: ALLOCATION_STATUS.REQUESTED,
    value: ALLOCATION_STATUS.REQUESTED,
  },
  {
    id: 9,
    label: ALLOCATION_STATUS.RESUBMISSION,
    value: ALLOCATION_STATUS.RESUBMISSION,
  },
  {
    id: 10,
    label: ALLOCATION_STATUS.NOTELIGIBLE,
    value: ALLOCATION_STATUS.NOTELIGIBLE,
  },
];

export const ALLOCATION_STATUS_OPTIONS = [
  {
    id: 7,
    label: ALLOCATION_STATUS.REQUESTED,
    value: ALLOCATION_STATUS.REQUESTED,
    displayLabel: (
      <div className="requested-status">{ALLOCATION_STATUS.REQUESTED}</div>
    ),
  },
  {
    id: 1,
    label: ALLOCATION_STATUS.PENDING,
    value: ALLOCATION_STATUS.PENDING,
    displayLabel: (
      <div className="pending-status">{ALLOCATION_STATUS.PENDING}</div>
    ),
  },
  {
    id: 2,
    label: ALLOCATION_STATUS.PROCESSED,
    value: ALLOCATION_STATUS.PROCESSED,
    displayLabel: (
      <div className="processed-status">{ALLOCATION_STATUS.PROCESSED}</div>
    ),
  },
  {
    id: 3,
    label: ALLOCATION_STATUS.INPROGRESS,
    value: ALLOCATION_STATUS.INPROGRESS,
    displayLabel: (
      <div className="in-progress-status">{ALLOCATION_STATUS.INPROGRESS}</div>
    ),
  },
  {
    id: 4,
    label: APPROVED_STATUS_LABEL,
    value: ALLOCATION_STATUS.APPROVED,
    displayLabel: (
      <div className="approved-status">{APPROVED_STATUS_LABEL}</div>
    ),
  },
  {
    id: 5,
    label: DISAPPROVED_STATUS_LABEL,
    value: ALLOCATION_STATUS.DISAPPROVED,
    displayLabel: (
      <div className="disapproved-status">{DISAPPROVED_STATUS_LABEL}</div>
    ),
  },
  {
    id: 6,
    label: ALLOCATION_STATUS.DOWNLOADED,
    value: ALLOCATION_STATUS.DOWNLOADED,
    displayLabel: (
      <div className="downloaded-status">{ALLOCATION_STATUS.DOWNLOADED}</div>
    ),
  },
  {
    id: 8,
    label: ALLOCATION_STATUS.RESUBMISSION,
    value: ALLOCATION_STATUS.RESUBMISSION,
    displayLabel: (
      <div className="resubmission-status">
        {ALLOCATION_STATUS.RESUBMISSION}
      </div>
    ),
  },
  {
    id: 9,
    label: ALLOCATION_STATUS.NOTELIGIBLE,
    value: ALLOCATION_STATUS.NOTELIGIBLE,
    displayLabel: (
      <div className="disapproved-status">{ALLOCATION_STATUS.NOTELIGIBLE}</div>
    ),
  },
];

export const ATTENDANCE_STATUS = {
  INVITED: "Invited",
  CONFIRMED: "Confirmed",
  DECLINED: "Declined",
  NORESPONSE: "No Response",
  ATTENDED: "Attended",
  DIDNOTATTEND: "Did Not Attend",
};

export const ATTENDANCE_STATUS_OPTIONS = [
  {
    id: 7,
    label: ATTENDANCE_STATUS.INVITED,
    value: ATTENDANCE_STATUS.INVITED,
    displayLabel: (
      <div className="invited-status">{ATTENDANCE_STATUS.INVITED}</div>
    ),
  },
  {
    id: 1,
    label: ATTENDANCE_STATUS.CONFIRMED,
    value: ATTENDANCE_STATUS.CONFIRMED,
    displayLabel: (
      <div className="confirmed-status">{ATTENDANCE_STATUS.CONFIRMED}</div>
    ),
  },
  {
    id: 2,
    label: ATTENDANCE_STATUS.DECLINED,
    value: ATTENDANCE_STATUS.DECLINED,
    displayLabel: (
      <div className="declined-status">{ATTENDANCE_STATUS.DECLINED}</div>
    ),
  },
  {
    id: 3,
    label: ATTENDANCE_STATUS.NORESPONSE,
    value: ATTENDANCE_STATUS.NORESPONSE,
    displayLabel: (
      <div className="no-response-status">{ATTENDANCE_STATUS.NORESPONSE}</div>
    ),
  },
  {
    id: 4,
    label: ATTENDANCE_STATUS.ATTENDED,
    value: ATTENDANCE_STATUS.ATTENDED,
    displayLabel: (
      <div className="attended-status">{ATTENDANCE_STATUS.ATTENDED}</div>
    ),
  },
  {
    id: 5,
    label: ATTENDANCE_STATUS.DIDNOTATTEND,
    value: ATTENDANCE_STATUS.DIDNOTATTEND,
    displayLabel: (
      <div className="did-not-attend-status">
        {ATTENDANCE_STATUS.DIDNOTATTEND}
      </div>
    ),
  },
];
